import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ThemeService } from '../../../common/services/theme.service';

@Component({
    selector: 'service-unavailable',
    templateUrl: './service-unavailable.component.html',
    styleUrls: ['./service-unavailable.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceUnavailableComponent implements OnInit, OnDestroy {

    public isRetrying = false;
    public lastChecked: Date | null = null;

    constructor(
        private http: HttpClient,
        private router: Router,
        private themeService: ThemeService
    ) { }

    ngOnInit(): void {
        this.themeService.forceLightMode();
        this.lastChecked = new Date();
    }

    ngOnDestroy(): void {
        this.themeService.restoreTheme();
    }

    public retryConnection(): void {
        this.isRetrying = true;
        this.lastChecked = new Date();

        // Try a simple health check endpoint
        // No custom header: on the cross-origin API it needs a CORS preflight the server refuses.
        this.http.get(`${environment.apiUrl}/system/health/`).pipe(
            timeout(5000)
        ).subscribe({
            next: () => {
                // Connection successful, redirect to home
                this.isRetrying = false;
                this.router.navigate(['/']);
            },
            error: () => {
                // Still not available
                this.isRetrying = false;
                // Could show a more specific error message here
            }
        });

        // Fallback timeout in case the request hangs
        setTimeout(() => {
            this.isRetrying = false;
        }, 10000);
    }
}
